/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum RegisterPermissionType {
  UpdateRegister = 10,
  ExportRegister = 20,
  DeleteRegister = 30,
  CreateInvitation = 40,
  DeleteInvitation = 50,
  ListUsers = 60,
  UpdateUser = 70,
  DeleteUser = 80,
  CreateIntegrationConnection = 90,
  UpdateIntegrationConnection = 100,
  CallIntegrationConnection = 105,
  DeleteIntegrationConnection = 110,
  CreateClassification = 120,
  UpdateClassification = 130,
  DeleteClassification = 140,
  CreateAssetGroup = 150,
  UpdateAssetGroup = 160,
  DeleteAssetGroup = 170,
  CreateAsset = 180,
  UpdateAsset = 190,
  ExportAsset = 200,
  DeleteAsset = 210,
  UpdateDraftAsset = 220,
  CreateJournal = 230,
  UpdateJournal = 240,
  DeleteJournal = 250,
  CreateReport = 260,
  CreateAssetImport = 270,
  UpdateAssetImport = 280,
  RollbackAssetImport = 290,
  DeleteAssetImport = 300,
  CreateCustomField = 310,
  UpdateCustomField = 320,
  DeleteCustomField = 330,
  CreateBulkAction = 340,
  UpdateBulkAction = 350,
  RollbackBulkAction = 360,
  DeleteBulkAction = 370,
  CreateNotes = 440,
  UpdateNotes = 450,
  DeleteNotes = 460,
}
